import { Controller } from "stimulus";
import flatpickr from "flatpickr";

export default class CarouselController extends Controller {
  initialize() {
    flatpickr(this.element, {});
  }
}
